import { Link } from "react-router-dom";
import { HeroEditorial } from "@/components/home/HeroEditorial";
import { EditorialGallery } from "@/components/home/EditorialGallery";
import { WhatIfFabric } from "@/components/home/WhatIfFabric";
import { HandmadeEditorial } from "@/components/home/HandmadeEditorial";
import { FabricStrip } from "@/components/home/FabricStrip";
import { FinalCta } from "@/components/home/FinalCta";
import { ChristmasPostcard } from "@/components/agenda/ChristmasPostcard";
import { CollectionImage } from "@/components/collections/CollectionImage";
import { featuredCollections } from "@/lib/catalog";
import { usePageMeta } from "@/lib/seo";

// Coleção em destaque como secção própria (definida no painel, em Coleções): fotografia da coleção, título, texto e botão.
const CollectionSection = ({ c }) => (
  <section className="bb-container py-10 sm:py-14" data-testid={`home-collection-${c.slug}`} aria-label={c.feature.title}>
    <Link to={`/colecoes/${c.slug}`} className="group relative block min-h-[320px] overflow-hidden rounded-3xl bg-[#3d332d] text-ivory sm:min-h-[400px]">
      <CollectionImage image={c.feature.image} alt="" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <span className="absolute inset-0 bg-[linear-gradient(90deg,rgba(43,36,32,.62)_0%,rgba(43,36,32,.25)_60%,rgba(43,36,32,.05)_100%)]" aria-hidden="true" />
      <span className="relative z-10 flex min-h-[320px] max-w-[560px] flex-col justify-end gap-3 p-6 sm:min-h-[400px] sm:justify-center sm:p-10">
        <span className="bb-eyebrow !text-ivory">{c.label}</span>
        <span className="bb-h2 text-ivory [text-shadow:0_1px_18px_rgba(30,24,20,.3)]">{c.feature.title}</span>
        {c.feature.text && <span className="text-[16px] leading-[1.55] text-ivory/95">{c.feature.text}</span>}
        <span className="mt-1 inline-flex w-fit items-center gap-1.5 rounded-full bg-ivory px-6 py-3 text-sm font-semibold text-bordeaux">{c.feature.buttonLabel} →</span>
      </span>
    </Link>
  </section>
);

export default function HomePage() {
  usePageMeta(null, "Babybib: peças feitas à mão para bebé, pela Alexandra. Escolhe a peça e o tecido: babetes, porta-chupetas, tapa-fraldas, coelhinhos e muito mais.");
  const sections = featuredCollections("section").filter((c) => c.feature.image?.id);
  return (
    <>
      <HeroEditorial />
      <ChristmasPostcard />
      <EditorialGallery />
      {sections.map((c) => <CollectionSection key={c.slug} c={c} />)}
      <WhatIfFabric />
      <HandmadeEditorial />
      <FabricStrip />
      <FinalCta />
    </>
  );
}
